import { format } from 'date-fns';

export const formatDate = (date: Date | string, dateFormat: string) => {
  const newDate = new Date(date);

  newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
  return format(newDate, dateFormat);
};
